export default __webpack_public_path__ + "static/media/Transistos.fae6206b.mp3";